// Only the pages a candidate opens from a message (upload and chat links); other keys fall back to English.
export default {
  'date.format': 'dd.MM.yyyy',
  'date.format_datetime': 'dd.MM.yyyy HH:mm',

  'common.network_error': "Une erreur réseau s'est produite. Veuillez réessayer.",
  'common.loading': 'Chargement…',

  'candidate.public.error_generic': "Une erreur s'est produite. Veuillez réessayer plus tard.",

  'candidate.public_upload.title': 'Télécharger vos fichiers',
  'candidate.public_upload.intro':
    "{company} vous demande des informations complémentaires. Merci de l'intérêt que vous portez à notre offre d'emploi.",
  'candidate.public_upload.intro_no_company':
    "Des informations complémentaires vous sont demandées. Merci de l'intérêt que vous portez à notre offre d'emploi.",
  'candidate.public_upload.request_cv': 'Veuillez télécharger votre CV.',
  'candidate.public_upload.request_reference': 'Veuillez télécharger vos lettres de référence.',
  'candidate.public_upload.request_custom': 'Veuillez télécharger les fichiers demandés.',
  'candidate.public_upload.drop_hint': 'Déposez vos fichiers ici ou cliquez pour les parcourir',
  'candidate.public_upload.constraints':
    "PDF, Word (.docx), JPG ou PNG · max. {size} Mo par fichier · jusqu'à {count} fichiers",
  'candidate.public_upload.remove_file': 'Supprimer {name}',
  'candidate.public_upload.submit': 'Envoyer',
  'candidate.public_upload.submit_count': 'Envoyer {count} fichiers',
  'candidate.public_upload.success_title': 'Merci !',
  'candidate.public_upload.success_text': 'Vos fichiers ont bien été reçus.',
  'candidate.public_upload.fulfilled_title': 'Fichiers déjà reçus',
  'candidate.public_upload.fulfilled_text': 'Des fichiers ont déjà été téléchargés via ce lien.',
  'candidate.public_upload.cancelled_title': 'Cette demande de fichiers a été retirée.',
  'candidate.public_upload.expired_title': 'Ce lien de téléchargement a expiré.',
  'candidate.public_upload.error_invalid': 'Ce lien de téléchargement est invalide ou a expiré.',
  'candidate.public_upload.error_duplicate': '« {name} » figure déjà dans la liste.',
  'candidate.public_upload.error_too_many': 'Vous pouvez télécharger {count} fichiers au maximum.',
  'candidate.public_upload.error_too_large': '« {name} » dépasse {size} Mo.',
  'candidate.public_upload.error_type':
    "« {name} » n'est pas un type de fichier accepté. Veuillez utiliser un fichier PDF, Word (.docx), JPG ou PNG.",
  'candidate.public_upload.upload_failed': 'Le téléchargement a échoué. Veuillez réessayer.',
  'candidate.public_upload.order_finished':
    "Cette offre d'emploi n'est plus publiée. Il n'est plus possible de télécharger des fichiers.",

  'candidate.public_chat.title': 'Votre conversation',
  'candidate.public_chat.title_company': 'Votre conversation avec {company}',
  'candidate.public_chat.intro': 'Lisez les messages de {company} et répondez ci-dessous.',
  'candidate.public_chat.intro_no_company': "Lisez les messages concernant l'offre d'emploi et répondez ci-dessous.",
  'candidate.public_chat.reply_label': 'Votre réponse',
  'candidate.public_chat.no_messages': 'Aucun message pour le moment.',
  'candidate.public_chat.reply_placeholder': 'Écrivez votre réponse…',
  'candidate.public_chat.send': 'Envoyer la réponse',
  'candidate.public_chat.reply_error': "Votre réponse n'a pas pu être envoyée. Veuillez réessayer.",
  'candidate.public_chat.error_invalid': 'Ce lien de conversation est invalide ou a expiré.',
  'candidate.public_chat.order_finished':
    "Cette offre d'emploi n'est plus publiée. La conversation n'est plus disponible.",
};
